export default "__VITE_ASSET__CoyRFU69__"